import React, { useState } from 'react';

import Button from 'shared/button';
import Snackbar from 'shared/snackbar';
import confirm from 'components/confirm';
import { deleteRequest } from 'helpers/api';

import type { Grant } from '../types';
interface Props {
  destroyPath: string;
  grant: Grant;
  onDestroy: () => void;
}

export default function ExistingNylasGrant({ destroyPath, grant, onDestroy }: Props) {
  const [destroying, setDestroying] = useState(false);
  const [showError, setShowError] = useState(false);

  async function destroy() {
    try {
      await confirm('Are you sure you want to disconnect this integration?', {
        buttonLabel: 'Disconnect',
        buttonStyle: 'danger',
        title: 'Disconnect Integration',
      });
    } catch (e) {
      return;
    }

    try {
      setDestroying(true);
      await deleteRequest(destroyPath);
    } catch (e) {
      setShowError(true);
      return;
    } finally {
      setDestroying(false);
    }

    onDestroy();
  }

  return (
    <div className="d-flex align-items-center">
      <div className="mr-4">Connected to {grant.email} via {grant.provider}</div>
      <Button.Danger disabled={destroying} label="Disconnect" onClick={destroy} />

      <Snackbar
        show={showError}
        text="Something went wrong"
        variant="danger"
        onClose={() => setShowError(false)}
      />
    </div>
  );
}
